import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocationService } from '@services';
import { Observable, tap } from 'rxjs';

@Injectable()
export class LocationInterceptor implements HttpInterceptor {
  constructor(private locationService: LocationService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Do nothing if country is already set
    if (this.locationService.getCountryCode()) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          const countryCode = event.headers.get('x-country-code');
          if (countryCode) {
            this.locationService.setCountryCode(countryCode);
          }
        }
      }),
    );
  }
}
